export default __webpack_public_path__ + "static/media/bulletLargeBlueYellow.314eac3c.svg";